import React, { useContext, useEffect, useState } from "react";
import { CDN_BASE_URL } from "../../../config";
import HeartIcon from "../../../icons/HeartIcon";
import ShareModal from "./ShareModal";
import ShareIcon from "../../../icons/ShareIcon";
import ChatIcon from "../../../icons/ChatIcon";
import BookIcon from "../../../icons/BookIcon";
import { priceComma } from "../../../utils/priceComma";
import { Link } from "react-router-dom";
import axios from "axios";
import { httpReauest } from "../../../utils/httpRequest";
import { ProductContext } from "../../../context/ProductContext";

const ProductCardSpecialMobile = ({ data, key, compelete }) => {
  const [share, setShare] = useState();
  const url = `https://1924.ir/${data?.url?.category?.url}/${data?.url?.brand?.name}/${data?.url?.name}`;

  const [liked, setLiked] = useState();
  const [count, setcount] = useState(0);

  const { setselectProduct } = useContext(ProductContext);

  useEffect(() => {
    if (data?.liked) {
      setLiked(true);
    }
    setcount(data?.like);
  }, []);

  async function handleLike() {
    if (!liked) {
      setLiked(true);
      setcount(count + 1);
      const { data: data2 } = await axios.get(
        "https://api.ipify.org/?format=json"
      );
      await httpReauest(
        "POST",
        "/vehicle/like",
        { ip: data2.ip, vehicle: data?._id },
        {}
      );
    } else {
      setLiked(false);
      setcount(count - 1);
      const { data: data2 } = await axios.get(
        "https://api.ipify.org/?format=json"
      );
      await httpReauest(
        "DELETE",
        "/vehicle/like/delete",
        { ip: data2.ip, vehicle: data?._id },
        {}
      );
    }
  }

  return (
    <div
      key={key}
      style={{
        background:
          !data?.sell && !compelete
            ? "linear-gradient(87.61deg, #DE2F2F -6.14%, #610000 96.05%)"
            : "#fff",
        border: "1px solid #DE2F2F",
      }}
      className={"p-1 rounded-[10px] mt-5 relative "}
    >
      {!compelete && data?.sell && (
        <img
          src={"/sold.png"}
          alt="sell item"
          className="absolute w-full h-full left-0 top-0 z-20"
        />
      )}
      {compelete && (
        <p className="absolute top-[50%] text-center left-[50%] translate-x-[-50%] translate-y-[-50%] text-white text-[30px] px-3 z-30">
          پایان مهلت فروش ویژه
        </p>
      )}
      <Link
        onClick={() => setselectProduct(data?._id)}
        to={`/${data?.url?.category?.url}/${data?.url?.brand?.name}/${data?.url?.name}`}
      >
        <img
          src={CDN_BASE_URL + data?.img}
          className={`${
            (data?.sell || compelete) && "grayscale"
          } w-full rounded-[10px] mb-1`}
          alt={data?.name}
          title={data?.name}
        />
      </Link>

      <div
        className={`flex justify-between items-center py-2 px-1 ${
          data?.sell || compelete ? "text-[#777]" : "text-white"
        } `}
      >
        <span className="flex gap-3 items-center">
          <span className="flex gap-2 items-center">
            {" "}
            <HeartIcon
              select={liked}
              onClick={handleLike}
              color={data?.sell || compelete ? "#777" : "#fff"}
            />
            <p>{count}</p>
          </span>
          <span className="flex gap-2 items-center">
            {" "}
            <ChatIcon color={data?.sell || compelete ? "#777" : "#fff"} />
            <p>{data?.commentCount}</p>
          </span>
        </span>
        <span className="flex gap-3 items-center">
          <span
            onClick={() => setShare(true)}
            className="flex gap-2 items-center"
          >
            {" "}
            <BookIcon color={data?.sell || compelete ? "#777" : "#fff"} />
          </span>
        </span>
      </div>
      <Link
        onClick={() => setselectProduct(data?._id)}
        to={`/${data?.url?.category?.url}/${data?.url?.brand?.name}/${data?.url?.name}`}
        className={`flex justify-between items-center  font-[700] ${
          data?.sell || compelete ? "text-[#777] grayscale" : "text-white"
        } text-[18px] px-1 pt-3 pb-2`}
      >
        <h2>{data?.name}</h2>
        <p className={`relative ${data?.special_price && "price-line-white"}`}>
          {data?.no_price ? "توافقی" : priceComma(data?.price * 1000000000, 2)}

          {data?.special_price && (
            <>
              <br />
              {priceComma(data?.special_price * 1000000000, 2)}
            </>
          )}
        </p>
      </Link>
      {share && <ShareModal url={url} setShare={setShare} />}
    </div>
  );
};

export default ProductCardSpecialMobile;
